import { useCallback, useState } from "react";
import { useFeedback } from "../Feedback";

/**
 * API 動作 + 訊息回饋 hook（design system）。
 * 執行一個 API 呼叫，依結果自動跳成功/失敗 toast（罐頭訊息），並提供 loading 狀態。
 * api_helper 攔截器會把錯誤轉成字串訊息，這裡直接拿來當 toast 內容。
 *
 *   const { run, loading } = useApiAction();
 *   <Button loading={loading} onClick={() =>
 *     run(() => usersApi.create(values), {
 *       success: "使用者已建立並送審",
 *       error: "建立失敗",        // 可省略；省略時用後端回傳訊息
 *       onSuccess: (res) => refetch(),
 *     })
 *   }>儲存</Button>
 */
export function useApiAction() {
  const fb = useFeedback();
  const [loading, setLoading] = useState(false);

  const run = useCallback(
    async (apiCall, opts = {}) => {
      const { success, error, onSuccess, onError, silent = false } = opts;
      setLoading(true);
      try {
        const res = await apiCall();
        if (!silent && success) fb.success(success);
        if (onSuccess) onSuccess(res);
        return res;
      } catch (err) {
        const msg = error || (typeof err === "string" ? err : "操作失敗，請稍後再試");
        if (!silent) fb.error(msg);
        if (onError) onError(err);
        return undefined;
      } finally {
        setLoading(false);
      }
    },
    [fb]
  );

  return { run, loading };
}

export default useApiAction;
